import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, shape }: Theme) => ({
  root: {
    fontFamily: 'Lato',
  },
  textFieldRoot: {
    minHeight: 43,
    '&.Mui-error input::placeholder': {
      color: custom.status.danger.contrastText,
      opacity: 1,
    },
    '& $notchedOutline': {},
  },
  notchedOutline: {},
  startAdornmentIcon: {
    color: custom.grey[4],
  },
  listbox: {
    padding: 5,
    overflow: 'initial',
  },
  option: {
    borderRadius: shape.borderRadius,
    paddingLeft: 10,
    paddingRight: 10,
  },
  hidden: {
    display: 'none',
  },
  popper: {
    zIndex: 1301,
  },
  popperDisablePortal: {
    top: '100%',
  },
  inputHidden: {
    position: 'absolute',
    zIndex: -1,
  },
}));
